import { render, staticRenderFns } from "./badPerson.vue?vue&type=template&id=07be10e4&scoped=true&"
import script from "./badPerson.vue?vue&type=script&lang=js&"
export * from "./badPerson.vue?vue&type=script&lang=js&"
import style0 from "./badPerson.vue?vue&type=style&index=0&id=07be10e4&scoped=true&lang=css&"
import style1 from "./badPerson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be10e4",
  null
  
)

export default component.exports